var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTindakan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7241 16.1382C18.2852 17.1695 15.4867 17.7482 12.6073 17.8085C9.72795 17.8688 6.90768 17.4078 4.4377 16.4793C4.06464 16.337 3.70158 16.1946 3.3481 16.032C3.12151 15.9311 2.85099 16.1068 2.86492 16.3545L3.07495 20.0891C3.13543 21.1645 4.03676 21.9989 5.11366 21.9763L20.2758 21.6588C21.354 21.6362 22.2201 20.763 22.2338 19.6847L22.2812 15.9479C22.2844 15.6997 22.0065 15.5355 21.7841 15.6459C21.4377 15.8232 21.0809 15.9807 20.7241 16.1382Z",
    fill: "#FFBF3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.793 6.03419C10.3146 6.04421 9.98248 5.56086 10.1634 5.11789C10.2637 4.87247 10.5001 4.71003 10.7651 4.70448L13.9041 4.63875C14.1691 4.6332 14.4121 4.7856 14.5225 5.02661C14.7219 5.46162 14.4103 5.95844 13.9319 5.96846L10.793 6.03419ZM17.8928 5.88552C17.0953 5.90222 16.3641 5.44347 16.0322 4.71815L15.8428 4.30415C15.5109 3.57884 14.7798 3.12008 13.9823 3.13678L10.6241 3.20711C9.82661 3.22381 9.11531 3.71276 8.81407 4.45133L8.64212 4.87291C8.34088 5.61148 7.62958 6.10043 6.83211 6.11713L4.61863 6.16348C3.5143 6.18661 2.63781 7.10059 2.66094 8.20492L2.76563 13.2044C2.76934 13.3818 2.86674 13.5439 3.0216 13.6305C5.29049 14.8947 8.09824 15.636 11.0529 15.7799C11.4075 15.7972 11.6938 16.0819 11.7013 16.4368C11.7089 16.8021 12.0113 17.0921 12.3766 17.0844L12.8122 17.0753C13.1775 17.0677 13.4675 16.7653 13.4599 16.3999C13.4525 16.045 13.7265 15.7485 14.08 15.7164C17.0279 15.4481 19.8021 14.5899 22.0135 13.2328C22.1651 13.1398 22.2561 12.9733 22.2523 12.7955L22.1477 7.79685C22.1245 6.69253 21.2106 5.81604 20.1062 5.83917L17.8928 5.88552Z",
    fill: "#FFBF3C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.144,
    y: 7.52197,
    width: 2,
    height: 6,
    transform: "rotate(-1.19963 11.144 7.52197)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.22827,
    y: 11.563,
    width: 2,
    height: 6,
    transform: "rotate(-91.1996 9.22827 11.563)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTindakan);
export default __webpack_public_path__ + "static/media/tindakan.1d716ad925373eb8bb5fb87dc1b494da.svg";
export { ForwardRef as ReactComponent };